import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  Grid,
  CardContent,
  TextField,
  InputAdornment,
  makeStyles,
  SvgIcon, InputLabel, Select, MenuItem, FormControl
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  formControl: {
    flex: 1,
    width: '100%',
  }
}));

const Toolbar = ({
  className, onFilterByIsDevelop, onFilterByIsAdomi, onSearch, ...rest
}) => {
  const classes = useStyles();

  const handleFilterByIsDevelop = (e) => {
    onFilterByIsDevelop(e?.target?.value);
  };

  const handleFilterByIsAdomi = (e) => {
    onFilterByIsAdomi(e?.target?.value);
  };

  const handleSearch = (e) => {
    onSearch(e?.target?.value);
  };

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="flex-end"
      >
        <Link to="/app/repartidores/crear">
          <Button
            color="primary"
            variant="contained"
          >
            Agregar Repartidor
          </Button>
        </Link>
      </Box>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Box maxWidth={500}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Buscar repartidor"
                    variant="outlined"
                    onChange={handleSearch}
                  />
                </Box>
              </Grid>
              <Grid item xs={3}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="filter">Filtrar por desarrollo</InputLabel>
                  <Select
                    required
                    name="filter"
                    labelId="Filtrar"
                    label="Selecciona una opción"
                    onChange={handleFilterByIsDevelop}
                  >
                    <MenuItem value="">
                      Todos
                    </MenuItem>
                    <MenuItem value="false">
                      Comunes
                    </MenuItem>
                    <MenuItem value="true">
                      De desarrollo
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="filter">Filtrar por Adomi</InputLabel>
                  <Select
                    required
                    name="filter"
                    labelId="Filtrar"
                    label="Selecciona una opción"
                    onChange={handleFilterByIsAdomi}
                  >
                    <MenuItem value="">
                      Todos
                    </MenuItem>
                    <MenuItem value="true">
                      Adomi
                    </MenuItem>
                    <MenuItem value="false">
                      No Adomi
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  onFilterByIsDevelop: PropTypes.func,
  onFilterByIsAdomi: PropTypes.func,
  onSearch: PropTypes.func
};

Toolbar.defaultProps = {
  className: '',
  onSearch: () => null
};

export default Toolbar;
